import React from "react";
import { InstitutionsCardGrid } from "design-components/institutionsCardGrid/InstitutionsCardGrid";
import type { BaseComponent } from "types/contentful";
import { contentfulBaseComponent } from "utils/contentfulBaseComponent";

const CardGridComponent = (props: BaseComponent) => {
  const args = contentfulBaseComponent(props);
  return <InstitutionsCardGrid {...args} />;
};

export default CardGridComponent;
